import { CompressorChannel } from '../../api';
import { CompressorChannelFragment } from '../graphql/generated/compressor.generated';

export function mapCompressorChannelFromSysApi(channel: CompressorChannelFragment): CompressorChannel {
	const {
		id,
		features,
		description: { constraints }
	} = channel;
	return {
		id,
		name: features.name?.name,
		features: {
			// FIXME: Replace
			compressor: {
				enabled: features.compressor?.enabled || false,
				ratio: features.compressor?.ratio || 0,
				threshold: features.compressor?.threshold || 0
			},
			compressorEngaged: {
				isMissing: !channel.description.features.compressorEngaged.supported
			},
			channelConfiguration: channel.description.features.channelConfiguration.supported
				? {
						enabled: channel.features.channelConfiguration?.enabled || false,
						isMissing: channel.features.channelConfiguration === null
				  }
				: undefined
		},
		constraints: {
			enabled: {
				isMissing: !constraints.compressor?.enabled.supported
			},
			ratio: {
				range: {
					min: constraints.compressor?.ratio.range?.min ?? 1,
					max: constraints.compressor?.ratio.range?.max ?? 100,
					step: constraints.compressor?.ratio.range?.step ?? 0.1
				},
				isMissing: !constraints.compressor?.ratio.supported
			},
			threshold: {
				range: {
					min: constraints.compressor?.threshold.range?.min ?? -60,
					max: constraints.compressor?.threshold.range?.max ?? 0,
					step: constraints.compressor?.threshold.range?.step ?? 0.1
				},
				isMissing: !constraints.compressor?.threshold.supported
			}
		}
	};
}
